import { CatalogStage, CdnImage } from '@markant-platform/shared/content/model';

export const MOCK_CATALOG_STAGE: CatalogStage = {
  elements: [
    {
      headline: 'test headline one',
      subline: 'test headline one',
      text: 'test text one',
      linkhref: {
        href: 'https://example.com',
        target: '_blank',
        text: 'test title',
      },
    },
    {
      headline: 'test headline two',
      subline: 'test headline two',
      text: 'test text two',
      linkhref: {
        href: '',
        target: '',
        text: '',
      },
    },
  ],
};

export const MOCK_CDN_IMAGE: CdnImage = {
  label: 'test label',
  url: 'https://example.com/my-image.png?q=90&format=auto',
  height: 200,
  width: 300,
};
